import React from 'react';
import { WorkshopResource } from '../../services/meetingService';
import { useLocale } from '../../context/LocaleContext';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopResourcesSectionProps {
  resources: WorkshopResource[];
}

const WorkshopResourcesSection: React.FC<WorkshopResourcesSectionProps> = ({ resources }) => {
  const { t } = useLocale();
  if (!resources.length) {
    return <p className={styles.helperText}>{t('workshop.2026.resources.empty')}</p>;
  }

  return (
    <ul className={styles.workshopResourceList}>
      {resources.map((resource) => {
        const external = /^https?:\/\//i.test(resource.url);
        return (
          <li key={resource.id} className={styles.workshopResourceItem}>
            <a
              href={resource.url}
              className={styles.workshopResourceLink}
              {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              {resource.title}
            </a>
            {resource.description?.trim() ? (
              <p className={styles.workshopResourceDesc}>{resource.description.trim()}</p>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
};

export default WorkshopResourcesSection;
